(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7362],{

/***/ 18872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ css; },
  "F4": function() { return /* binding */ keyframes; }
});

// UNUSED EXPORTS: cache, cx, flush, getRegisteredStyles, hydrate, injectGlobal, merge, sheet

// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(48711);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
;// CONCATENATED MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = (0,emotion_cache_browser_esm/* default */.Z)(options);

  cache.sheet.speedy = function (value) {

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered, undefined);
    (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: emotion_utils_browser_esm/* getRegisteredStyles.bind */.fp.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js





var _createEmotion = createEmotion({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    emotion_css_esm_merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),

/***/ 62804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ox": function() { return /* binding */ getCountries; },
  "IS": function() { return /* binding */ loginCallback; },
  "QO": function() { return /* binding */ userChangePassword; },
  "nu": function() { return /* binding */ userConfirmEmail; },
  "X1": function() { return /* binding */ userForgotPassword; },
  "cq": function() { return /* binding */ userGetProfile; },
  "Kv": function() { return /* binding */ userLogout; },
  "lf": function() { return /* binding */ userResendConfirmEmail; },
  "Fw": function() { return /* binding */ userRestorePassword; },
  "ii": function() { return /* binding */ userSignIn; },
  "EQ": function() { return /* binding */ userSignUp; },
  "lP": function() { return /* binding */ userUpdateProfile; }
});

// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/clients.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ClientsStatic;

(function (ClientsStatic) {
  ClientsStatic["register"] = "/v2/clients/sign-up";
  ClientsStatic["login"] = "/v2/clients/login";
  ClientsStatic["logout"] = "/v2/clients/logout";
  ClientsStatic["forgotPassword"] = "/v2/clients/send-forgot-pasword";
  ClientsStatic["changePassword"] = "/v2/clients/change-password";
  ClientsStatic["confirmEmail"] = "/v2/clients/confirm-email";
  ClientsStatic["resendConfirmEmail"] = "/v2/clients/resend-confirm-email";
  ClientsStatic["profile"] = "/v2/clients";
  ClientsStatic["updateProfile"] = "/v2/clients/edit?_method=PUT";
  ClientsStatic["countries"] = "/v2/clients/countries";
})(ClientsStatic || (ClientsStatic = {}));

var ClientsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description Send new password.
   */
  resetPassword: function resetPassword(userId) {
    return "/v2/clients/reset-password/" + userId;
  },

  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Send search params to callback for OAuth.
   */
  loginCallback: function loginCallback(provider) {
    return "/v2/clients/login/".concat(provider, "/callback");
  }
};
var ClientsEndpoints = _objectSpread(_objectSpread({}, ClientsDynamic), ClientsStatic);
;// CONCATENATED MODULE: ./api/clients/clients.request.ts


function userSignUp(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.register, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userSignIn(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.login, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function userLogout() {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.logout, null).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userForgotPassword(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.forgotPassword, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userRestorePassword(clientId, searchParams, body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resetPassword(clientId) + searchParams, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userChangePassword(body) {
  return (0,base_services_request/* patchResquest */.Ft)(ClientsEndpoints.changePassword, body).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function userConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.confirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userResendConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resendConfirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function loginCallback(provider, searchParams) {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.loginCallback(provider) + searchParams).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data.data;
  });
}
function userUpdateProfile(body) {
  var useMultipartFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.updateProfile, body, useMultipartFormData).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}
function userGetProfile() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.profile).then(function (_ref4) {
    var data = _ref4.data;
    return data.data;
  });
}
function getCountries() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.countries).then(function (_ref5) {
    var data = _ref5.data;
    return data.data;
  });
}

/***/ }),

/***/ 99109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0;
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 64467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ cambiar_clave; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/layouts/user-settings/index.tsx + 1 modules
var user_settings = __webpack_require__(74232);
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./shared/components/modals/error-modal/index.tsx
var error_modal = __webpack_require__(29036);
// EXTERNAL MODULE: ./shared/components/text-field/password-field.tsx
var password_field = __webpack_require__(54489);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js + 1 modules
var emotion_css_esm = __webpack_require__(18872);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/clients/clients.request.ts + 1 modules
var clients_request = __webpack_require__(62804);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/forms/change-passowrd-form/index.tsx
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function ChangePasswordForm(_ref) {
  var onSubmitSuccess = _ref.onSubmitSuccess;
  var t = (0,next_intl_cjs_production_min.useTranslations)("ProfileChangePassword.form");
  var tErrors = (0,next_intl_cjs_production_min.useTranslations)("error");

  var _useState = (0,react.useState)(null),
      responseErrors = _useState[0],
      setResponseErrors = _useState[1];

  var validationSchema = (0,es/* object */.Ry)({
    current_password: (0,es/* string */.Z_)().required(tErrors("required")),
    new_password: (0,es/* string */.Z_)().required(tErrors("required")),
    new_password_confirmation: (0,es/* string */.Z_)().required(tErrors("required")).oneOf([(0,es/* ref */.iH)("new_password"), null], tErrors("passwordMustMatch"))
  });
  var initialValues = {
    current_password: "",
    new_password: "",
    new_password_confirmation: ""
  };

  var _useMutation = (0,useMutation/* useMutation */.D)(clients_request/* userChangePassword */.QO, {
    onSuccess: function onSuccess(data) {
      if (onSubmitSuccess) {
        onSubmitSuccess(data);
      }
    },
    onError: setResponseErrors
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  var onSubmit = function onSubmit(values) {
    return mutate(values);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function () {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Form */.l0, {
      className: gridContainer
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      container: true,
      spacing: 3
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      margin: "auto"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(password_field/* default */.Z, {
      name: "current_password",
      label: t("field.current-password") + "*"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      margin: "auto"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(password_field/* default */.Z, {
      name: "new_password",
      label: t("field.new-password") + "*"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      margin: "auto"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(password_field/* default */.Z, {
      name: "new_password_confirmation",
      label: t("field.repeat-password") + "*"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      my: 3,
      className: formButtonsContainer
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      type: "submit",
      thin_button: true,
      fullWidth: true,
      disabled: isLoading,
      loadingMessage: isLoading ? t("buttons.submitLoading") : null
    }, t("buttons.submit")), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: pages_path/* CPagesPath.es.profile */.K.es.profile
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      thin_button: true,
      fullWidth: true,
      bg: "--color-brand-grey-secondary"
    }, t("buttons.undo"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(error_modal/* RequestErrorModal */.V, {
      open: !!responseErrors,
      error: responseErrors,
      close: function close() {
        return setResponseErrors(null);
      }
    }));
  });
}
var gridContainer = /*#__PURE__*/(0,emotion_css_esm/* css */.iv)( true ? {
  name: "dokb1u",
  styles: ".MuiInputBase-root{background-color:white;}"
} : 0);
var formButtonsContainer = /*#__PURE__*/(0,emotion_css_esm/* css */.iv)( true ? {
  name: "1jolgun",
  styles: "display:grid;justify-content:center;grid-template-columns:repeat(auto-fit, 280px);grid-gap:10px;direction:rtl"
} : 0);
;// CONCATENATED MODULE: ./pages/perfil/configuracion/cambiar-clave/index.tsx


function cambiar_clave_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












function CambiarClavePage(props) {
  var titleT = (0,next_intl_cjs_production_min.useTranslations)("title-pages");
  var t = (0,next_intl_cjs_production_min.useTranslations)("ProfileChangePassword");
  var router = (0,next_router.useRouter)();
  var user = (0,redux_hooks/* useAppSelector */.C)(function (state) {
    return state.Auth.user;
  });

  var _useState = (0,react.useState)(false),
      showSuccessAlert = _useState[0],
      setShowSuccessAlert = _useState[1];

  (0,react.useEffect)(function () {
    if (!user) router.push(pages_path/* CPagesPath.es.signin */.K.es.signin);
  });
  if (!user) return null;

  var onSubmitSuccess = function onSubmitSuccess() {
    return setShowSuccessAlert(true);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, titleT("profile-update-password"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PageTitle, null, t("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(ChangePasswordForm, {
    onSubmitSuccess: onSubmitSuccess
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(SuccessModal, {
    open: showSuccessAlert
  })));
}

function SuccessModal(_ref) {
  var open = _ref.open;
  var t = (0,next_intl_cjs_production_min.useTranslations)("ProfileChangePassword.success");
  var router = (0,next_router.useRouter)();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, {
    open: open,
    title: t("title"),
    body: t("message"),
    handleClose: function handleClose() {
      return router.push(pages_path/* CPagesPath.es.profile */.K.es.profile);
    },
    buttonText: t("link")
  });
}

CambiarClavePage.Layout = user_settings/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var cambiar_clave = (CambiarClavePage);

var PageTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1wm3ruv1"
} : 0)( true ? {
  name: "1gm5aam",
  styles: "color:var(--color-brand-blue-main);font-weight:500;margin-bottom:30px"
} : 0);

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1wm3ruv0"
} : 0)( true ? {
  name: "xakkz7",
  styles: "max-width:820px;margin:auto;padding:30px 20px"
} : 0);

/***/ }),

/***/ 78836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LabelField = function LabelField(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
    css: styles.label,
    className: "label-customs ".concat(props.positionLabel)
  }, props.label);
};

/* harmony default export */ __webpack_exports__["Z"] = (LabelField);
var styles = {
  label:  true ? {
    name: "8knltz",
    styles: "width:100%;display:block;padding-left:10px;font-size:0.9375rem;font-weight:600;line-height:21px;color:var(--color-brand-blue-main);vertical-align:bottom !important;margin-bottom:10px;&.center{text-align:center;}&.left:{text-align:left;}&.right:{text-align:right;}"
  } : 0
};

/***/ }),

/***/ 29036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ RequestErrorModal; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _components_message_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36481);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







/**
 * General purpose error modal for requests.
 * Pass either an `error` to parse from axios (AxiosError)
 * or a `message` string to display.
 */
function RequestErrorModal(_ref) {
  var open = _ref.open,
      title = _ref.title,
      error = _ref.error,
      message = _ref.message,
      buttonMsg = _ref.buttonMsg,
      close = _ref.close;
  var errorBody = message ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ErrorSubtitle, null, message) : error ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ParseReqError, error) : null;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_message_modal__WEBPACK_IMPORTED_MODULE_1__/* .ModalMessage */ .P, {
    open: open,
    variant: "error",
    title: title !== null && title !== void 0 ? title : "Error",
    body: errorBody,
    handleClose: close,
    buttonText: buttonMsg !== null && buttonMsg !== void 0 ? buttonMsg : "OK"
  });
}

function ParseReqError(_ref2) {
  var response = _ref2.response,
      request = _ref2.request;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_5__.useTranslations)("error.http");
  var errorsBody = null;
  var errorMsg = t("default"); // The request was made and the server responded with a status code
  // that falls out of the range of 2xx
  // console.log(response, 'a')

  if (response) {
    var status = response.status,
        _response$data = response.data,
        message = _response$data.message,
        errors = _response$data.errors;
    console.log(response, "a");

    if (message) {
      errorMsg = message;
    } else if (status > 499) {
      errorMsg = t("500");
    } else if (status === 401) {
      errorMsg = t("401");
    } else if (status === 403) {
      errorMsg = t("403");
    } else if (status === 404) {
      errorMsg = t("404");
    } else if ([409, 406].includes(status)) {
      errorMsg = t("406");
    }

    if (status === 422) {
      if (typeof errors === "object") {
        var parsedErrors = Object.values(errors).map(function (errors) {
          return errors;
        }).flat();
        console.log(parsedErrors);
        errorsBody = parsedErrors.length > 1 ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
          className: errorList,
          role: "list"
        }, parsedErrors.map(function (error, i) {
          return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
            key: i
          }, error);
        })) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("p", {
          className: singleError
        }, parsedErrors.at(0));
      }
    }
  } else if (request) {
    // The request was made but no response was received
    // `request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(request);
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ErrorSubtitle, null, errorMsg), errorsBody);
}

var ErrorSubtitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("strong",  true ? {
  target: "er2dai30"
} : 0)( true ? {
  name: "1lzd6zb",
  styles: "font-size:14px;margin-bottom:10px;color:var(--color-brand-grey-quaternary)"
} : 0);

var errorList = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)( true ? {
  name: "crumug",
  styles: "list-style:inside;text-align:left;margin:0 20px;margin-top:10px"
} : 0);
var singleError = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)( true ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : 0);

/***/ }),

/***/ 22900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ default_text_field; },
  "Z": function() { return /* reexport */ formik_text_field; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/text-field/default-text-field.tsx




var _excluded = ["label", "value", "errorsComponents"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function DefaultTextField(props) {
  var label = props.label,
      value = props.value,
      errorsComponents = props.errorsComponents,
      res = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var onChange = function onChange(e) {
    if (props !== null && props !== void 0 && props.onChange) {
      props.onChange(e);
    }
  };

  var config = _objectSpread(_objectSpread(_objectSpread({}, res), {
    id: props.name
  }), {}, {
    onChange: onChange
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    css: styles.contentInput,
    className: "content-input-field"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: label,
    positionLabel: props.positionLabel
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Input/* default */.Z, (0,esm_extends/* default */.Z)({
    label: undefined,
    css: styles.inputField,
    disableUnderline: true
  }, config, {
    value: value
  })), errorsComponents && /*#__PURE__*/react.cloneElement(errorsComponents));
}

/* harmony default export */ var default_text_field = (DefaultTextField);
var styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};

var Errors = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "eq6sl9n0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ./shared/components/text-field/formik-text-field.tsx



var formik_text_field_excluded = ["name", "onChange"];

function formik_text_field_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function formik_text_field_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? formik_text_field_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : formik_text_field_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formik_text_field_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function FormikTextField(props) {
  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var name = props.name,
      onChange = props.onChange,
      res = (0,objectWithoutProperties/* default */.Z)(props, formik_text_field_excluded);

  var handleChange = function handleChange(value) {
    if (value.target) {
      field.onChange(value);
    } else {
      helpers.setValue(value);
    }
  };

  var config = formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread({}, field), res), {
    id: name
  }), {}, {
    onChange: props.onChange || handleChange,
    errorsComponents: ErrorsComponents({
      meta: meta
    })
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(default_text_field, config);
}

/* harmony default export */ var formik_text_field = (FormikTextField);

var ErrorsComponents = function ErrorsComponents(_ref) {
  var meta = _ref.meta;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, meta.error && meta.touched && (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: formik_text_field_styles.inputErrors
  }, meta.error));
};

var formik_text_field_styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};
;// CONCATENATED MODULE: ./shared/components/text-field/index.tsx




/***/ }),

/***/ 93524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TogglePasswordIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22961);
/* harmony import */ var _mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72450);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var TogglePasswordIcon = function TogglePasswordIcon(props) {
  var handleToggle = props.handleToggle,
      showPassword = props.showPassword;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(InputAdornmentCustom, {
    position: "end"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: "button",
    "aria-label": "toggle password visibility",
    onClick: handleToggle,
    tabIndex: -1
  }, showPassword ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null)));
};

var InputAdornmentCustom = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,  true ? {
  target: "e1d6b4r80"
} : 0)( true ? {
  name: "anun7w",
  styles: "position:absolute;right:10px"
} : 0);

/***/ }),

/***/ 54489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PasswordField; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36864);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22900);
/* harmony import */ var _password_field_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93524);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);





function PasswordField(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showPassword = _useState[0],
      setShowPassword = _useState[1];

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    type: showPassword ? "text" : "password",
    endAdornment: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_password_field_toggle__WEBPACK_IMPORTED_MODULE_2__/* .TogglePasswordIcon */ .S, {
      showPassword: showPassword,
      handleToggle: function handleToggle() {
        return setShowPassword(!showPassword);
      }
    })
  }));
}

/***/ }),

/***/ 74232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user_settings; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
;// CONCATENATED MODULE: ./custom-hooks/use-user-settings-menu-items.hook.ts


var menu = [];
var locale;
function useUserSettingsMenuItems() {
  var t = (0,next_intl_cjs_production_min.useTranslations)("SettingsLayout");
  var currentLocale = (0,next_intl_cjs_production_min.useLocale)();
  if (locale !== currentLocale) menu = [];
  if (menu.length) return menu;
  menu = [{
    slug: t("links.header_personal-info"),
    link: pages_path/* CPagesPath.es.profile */.K.es.profile,
    icon: "/icons/user-profile.svg",
    style: "bold",
    children: [{
      slug: t("links.edit-profile"),
      link: pages_path/* CPagesPath.es.profileEditar */.K.es.profileEditar
    }, {
      slug: t("links.change-password"),
      link: pages_path/* CPagesPath.es.profileCambiarClave */.K.es.profileCambiarClave
    }]
  }, {
    slug: t("links.header_favorites-list"),
    icon: "/icons/favorites-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.profileFavorites */.K.es.profileFavorites
  }, {
    slug: t("links.header_search-history"),
    icon: "/icons/search-query-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.ProfileSearchHistory */.K.es.ProfileSearchHistory
  }, {
    slug: t("links.history"),
    icon: "/icons/search-query-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.ProfileLastedSee */.K.es.ProfileLastedSee
  }];
  return menu;
}
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/layouts/user-settings/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function UserSettingsLayout(_ref) {
  var children = _ref.children;
  var t = (0,next_intl_cjs_production_min.useTranslations)("SettingsLayout");
  var menu = useUserSettingsMenuItems();

  var _user = (0,redux_hooks/* useAppSelector */.C)(function (state) {
    return state.Auth.user;
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, _user && (0,emotion_react_browser_esm/* jsx */.tZ)("aside", {
    className: "sidebar"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, t("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
    items: menu
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "main"
  }, children));
}

function RecursiveItems(_ref2) {
  var items = _ref2.items,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? 0 : _ref2$padding;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, items.map(function (item) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      style: {
        paddingLeft: padding
      },
      className: padding == 0 ? "root" : "node",
      key: item.slug
    }, item.link ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: item.link
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      className: "link-tag"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, {
      item: item
    }))), item.children && (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
      items: item.children,
      padding: padding + 30
    })) : (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, {
      item: item
    }, item.children && (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
      items: item.children,
      padding: padding + 30
    })));
  }));
}

function ItemLabel(_ref3) {
  var _ref3$item = _ref3.item,
      icon = _ref3$item.icon,
      slug = _ref3$item.slug,
      style = _ref3$item.style,
      children = _ref3.children;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: [style !== null && style !== void 0 ? style : "thin", "label"].join(" ")
  }, typeof icon === "string" ? (0,emotion_react_browser_esm/* jsx */.tZ)((image_default()) // style={{paddingRight: "9"}}
  , {
    src: icon,
    alt: slug + " icon",
    width: 17,
    height: 17
  }) : icon && (0,emotion_react_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
    component: icon,
    inheritViewBox: true
  }), "\xA0", slug), children);
}

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efk798q0"
} : 0)( true ? {
  name: "bq82os",
  styles: "display:grid;grid-template-columns:250px 1fr;min-height:var(--main-height);.root{margin:20px 0 10px;}.node{margin-top:10px;}.link-tag{&:hover{text-decoration:underline;}}.label{display:flex;align-items:center;.bold{font-weight:700;color:var(--color-main-blue);}}.sidebar{padding:20px;background:#fafafa;overflow-y:auto;a{display:block;font-size:16px;margin-bottom:5px;}}@media (max-width: 899px){grid-template-columns:100%;aside.sidebar{display:none;}}"
} : 0);

/* harmony default export */ var user_settings = (UserSettingsLayout);

/***/ }),

/***/ 1283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CPagesPath; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UniversalLinks = {
  blog: "https://blog.remaxrd.com/"
};
var es = {
  home: "/",
  collection: "/collection",
  collection_properties: "/collection/propiedades",
  collection_agents_list: "/collection/agentes",
  collection_property_detail: function collection_property_detail(x) {
    return "/collection/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x.slug);
  },
  collection_agent_detail: function collection_agent_detail(x) {
    return "/collection/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  properties: "/propiedades",
  shop: "/propiedades/comprar",
  acquire: "/propiedades/alquilar",
  property_detail: function property_detail(x) {
    return "/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x === null || x === void 0 ? void 0 : x.slug);
  },
  project: "/proyectos",
  project_Detail: function project_Detail(x) {
    return "/proyecto/".concat(x.slug);
  },
  loan_form: "/prestamos/formulario",
  loan_mortgage: "/prestamos/hipotecarios",
  loan_calculator: "/prestamos/calculadora",
  franchises: "/franquicias",
  agents_list: "/listado/agentes",
  agent_detail: function agent_detail(x) {
    return "/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  agencies_list: "/listado/agencias",
  agency_detail: function agency_detail(x) {
    return "/agencia/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  frequent_questions: "/preguntas-frecuentes",
  join: "/agentes",
  termsAndCondition: "/terminos-condiciones",
  privacyPolitics: "/politica-privacidad",
  signin: "/acceder",
  profile: "/perfil",
  profileEditar: "/perfil/configuracion/editar-perfil",
  profileCambiarClave: "/perfil/configuracion/cambiar-clave",
  profileFavorites: "/perfil/configuracion/favoritos",
  ProfileSearchHistory: "/perfil/configuracion/busquedas",
  ProfileLastedSee: "/perfil/configuracion/historial-busquedas",
  signup: "/registrate",
  forgotPassword: "/restaurar-clave"
};
var CPagesPath = _objectSpread(_objectSpread({}, UniversalLinks), {}, {
  es: es
});

var HEncodeString = function HEncodeString(x) {
  return "".concat(x.replace(/\//g, "-").split(" ").join("-").toLowerCase());
};

var RealestateEncode = function RealestateEncode(x) {
  var _x$replaceAll;

  return x === null || x === void 0 ? void 0 : (_x$replaceAll = x.replaceAll("/", "o")) === null || _x$replaceAll === void 0 ? void 0 : _x$replaceAll.replaceAll(" ", "-").toLowerCase();
};

/***/ }),

/***/ 47484:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/cambiar-clave",
      function () {
        return __webpack_require__(64467);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,9043,8543,2960,7956,4864,5675,207,3282,2888,179], function() { return __webpack_exec__(47484); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);